
<script>
	export let secondsRemaining;
</script>

<div
	class="clock-container"
	class:low-time={secondsRemaining < 10}
	class:fast-pulse={secondsRemaining <= 0}>
		<span class="clock">
			{secondsRemaining}s
		</span>
</div>

<style lang="less">
	@import "../variables.less";

	.clock-container {
		width: 100%; max-width: 23vmin;
		text-align: center;
		font-size: 0.8em;
		font-weight: 700;

		&.low-time {
			.clock {
				color: #ff2626;
				border-color: #ff2626;
			}
		}
		.clock {
			display: inline-block;
			width: 4em; height: 4em;
			line-height: 4em;
			padding: 0 1em;
			color: white;
			background: rgba(0,0,0,0.65);
			text-shadow: 0 0 3px rgba(0, 0, 0, 0.5);
			border: 0.1em solid white;
			border-radius: 100%;
		}
	}
</style>
